import React from "react";
import { useTranslate } from "../i18n";

export default function RouteFallback() {
  const { t } = useTranslate();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--page-bg)",
        color: "var(--muted2)",
        fontSize: 13,
        fontWeight: 600,
      }}
    >
      {t("layout.loading")}
    </div>
  );
}
